import { defineSlotRecipe } from '@chakra-ui/react';

export const reservationSwitchSlotRecipe = defineSlotRecipe({
    slots: ['wrapper', 'icon', 'label'],
    base: {
        wrapper: {
            borderRadius: 'tileImage',
            bgColor: 'orange.50',
            gap: 2,
            px: 3,
            py: 4,
        },
        icon: {
            flex: '0 0 auto',
            mr: 2,
            alignSelf: 'center',
        },
        label: {
            textAlign: 'left',
            fontSize: 'xs',
            fontWeight: 'bold',
            alignSelf: 'center',
        },
    },

    variants: {
        variant: {
            sticky: {
                wrapper: {
                    py: 2,
                },
            },
        },
    },
});
